import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Campania } from '../../../_models/campania';
import { Funcionalidad } from '../../../_models/funcionalidad';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { CampaniaDctoMontos } from '../../../_models/campania-dcto-montos';
import { CampaniaDctoMontoservice } from '../../../_services/campania-dcto-monto.service';
import { Table } from 'primeng/table';
import { CampaniaDctoCiclos } from '../../../_models/campania-dcto-ciclos';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-campanias-dcto-montos-detalle',
  templateUrl: 'campanias-dcto-montos-detalle.component.html'
} )

export class CampaniasDctoMontosDetalleComponent implements OnInit {

  @Input() campania: Campania;
  campaniaDctoMontos: CampaniaDctoMontos;
  // Lista de campañas descuentos Montos
  lisCampaniasDctoMontos: CampaniaDctoMontos [] = [];
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  tabSeleccionado = 'CAMM';
  carTabla = true;
  @ViewChild('dt') tabla: Table;

  constructor( private autServicio: AutenticacionService,
               private camDctoMontoservicio: CampaniaDctoMontoservice,
               private conServicio: ConfirmationService,
               private nav: NavService,
               private confirmationService: ConfirmationService,
               private fb: FormBuilder,
               private location: Location) {

  }

  ngOnInit(): void {
    // Definiendo columnas datatable
    this.columnas = [
      { field: 'montoMinimo', header: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.LBL_MONTOMINIMO' ), sort: false },
      { field: 'montomaximo', header: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.LBL_MONTOMAXIMO' ), sort: false },
      { field: 'descuentoTasa', header: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.LBL_DESCUENTOTASA' ), sort: false },
    ];
    // Inicializando formulario
    this.cargarTabla();
  }




  cargarTabla() {
    this.lisCampaniasDctoMontos = [];
    this.camDctoMontoservicio.listadoCampaniasDctoMontosIdCampania( this.campania.idCampania ).subscribe( res => {
      this.lisCampaniasDctoMontos = res;
      this.carTabla = false;
      this.carInformacionInicial = false;
    } );
  }

  obtenerCampanias() {
    return this.lisCampaniasDctoMontos.filter( x => x.indicadorHabilitado );
  }

  regresar() {
    this.location.back();
  }

  get f() {
    return this.formulario.controls;
  }

}
